export type ProductEvent = 'download_image' | 'download_image_failed' | 'photo_permission' | 'share_sheet_opened'
  | 'share_completed' | 'share_target_selected' | 'lens_draft_saved' | 'lens_published' | 'lens_try';

export const PRODUCT_EVENT_LABELS: Record<ProductEvent, string> = {
  download_image: 'Images saved to album', download_image_failed: 'Image save failed / unconfirmed', photo_permission: 'Photo permission outcomes',
  share_sheet_opened: 'Share opened', share_completed: 'Share completed (iOS)', share_target_selected: 'Share target selected (Android)',
  lens_draft_saved: 'Lens draft saved', lens_published: 'Lens published', lens_try: 'Lens selected to try',
};

export interface ProductEventTotal { event: ProductEvent; count: number; users: number; images: number }
export interface ProductEngagement {
  period: { startDate: string; endDate: string; days: number; timeZone: 'Asia/Hong_Kong' };
  generatedAt: string;
  scope: 'external';
  events: ProductEventTotal[];
  sessions: { sessions: number; users: number; durationMs: number; avgSessionMs: number | null; avgUserMs: number | null };
  daily: Array<{ date: string; events: Record<ProductEvent, number>; sessions: number; durationMs: number }>;
  breakdowns: Array<ProductEventTotal & { platform: string; source: string; contentType: string; imageType: string; stage: string; reason: string; result: string }>;
  breakdownsTruncated: boolean;
  lenses: Array<{ extensionId: string; name: string; drafts: number; publishes: number; tries: number; users: number }>;
  topUsers: Array<{ userId: string; name: string; sessions: number; durationMs: number }>;
  retentionLimited: boolean;
  notes: string[];
}
